export default "__VITE_ASSET__Da4x$Jyd__"